// Info de versión del build.
// Los valores se inyectan al compilar (ver scripts build-js/start-js en package.json):
//   REACT_APP_VERSION   -> versión de package.json (semver, se sube en cada release)
//   REACT_APP_BUILD_HASH-> hash corto del commit (trazabilidad)
//   REACT_APP_BUILD_DATE-> fecha del build
// En dev, si no están seteadas, caen a un fallback.
export default {
    version: process.env.REACT_APP_VERSION || 'dev',
    hash: process.env.REACT_APP_BUILD_HASH || '',
    date: process.env.REACT_APP_BUILD_DATE || '',
};



// WEBPACK FOOTER //
// ./src/version.js